import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import {
  CalendarIcon,
  ChevronLeft,
  ChevronRight,
  Eye,
  IdCard,
  ListIcon,
  Pencil,
} from "lucide-react";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../../component/table/filter-table/dynamic-filter";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import CustomizeTabsPopup from "../../../../../component/table/customize-table";
import DotsVerticalIcon from "../../../../../component/icons/dots-vertical";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../../component/table/table-layout";
import LeadQuickView from "../../../../mainleads/leads/lead/popup";
import ContactQuickView from "../../../../mainAccounts/accounts/contact/popup";
import AccountQuickView from "../../../../mainAccounts/accounts/account/popup";
import DealQuickView from "../../../../mainDeals/deals/deal/popup";
import InnerLoader from "../../../../../component/ui/loader/inner-loader";
import ProjectQuickView from "../../../../projects/project/popup";
import DataNotFound from "../../../../../component/ui/loader/data-not-found";

const TopAccountList = () => {
  const masterCheckboxRef = useRef();
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [changeModal, setChangeModal] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [currentStatus, setCurrentStatus] = useState("");
  const [tableHeader, setTableHeader] = useState([]);
  const [quickViewType, setQuickViewType] = useState(null);
  const [empData, setEmpData] = useState({});
  const [pageItemsCount, setPageItemsCount] = useState(10);

  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
  }, []);

  const getData = async ({
    filter = filterReturn,
    page,
    page_quantity = pageItemsCount,
  }) => {
    if (!page) {
      setIsLoading(true);
    }
    let apiData = { page: page, page_quantity: 10 };
    let extraUrl = `&page=${page || 1}&page_quantity=${page_quantity}`;
    for (let i = 0; i < filter?.length; i++) {
      extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
    }

    try {
      const res = await apiCall({
        method: "get",
        url: `accounts/accounts-overview-top-account?${extraUrl}`,
        data: apiData,
      });
      if (page) {
        setApiData((prev) => [...prev, ...res.data]);
      } else {
        setApiData(res.data);
      }
      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);

      setTablePagination(res?.pagination);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const filterModalData = [
    {
      name: "date_filter",
      label: "By Date",
      options: ["is", "between"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "Today", value: "today" },
        { label: "Yesterday", value: "yesterday" },
        { label: "This Week", value: "this_week" },
        { label: "This Month", value: "this_month" },
      ],
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
    },
  ];

  const tableRef = useRef(null);

  return (
    <>
      <div className={`${Style.mainBody}`}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              {/* HEADER */}
              <div className={Style.empDirectory_header}>
                <div className="flex justify-between items-center w-full">
                  <div className="text-xl font-bold pl-3 flex items-center gap-1 leading-10 ">
                    Top Accounts
                  </div>
                  <div className="text-[#A4A7AE] transition-all duration-300 hover:text-gray-500 cursor-pointer">
                    <DotsVerticalIcon />
                  </div>
                </div>
              </div>
              {/* BODY */}
              <div className={Style.empDirectory_body}>
                {isLoading ? (
                  <InnerLoader />
                ) : !apiData?.length ? (
                  <DataNotFound title={"Top Accounts"} />
                ) : (
                  <div className="w-full h-full !overflow-auto">
                    <Table ref={tableRef}>
                      <TableHead>
                        <TableRow>
                          <TableCell header sticky>
                            <TableHeaderWrap>
                              <span className="pl-[50px]">Name</span>
                            </TableHeaderWrap>
                          </TableCell>
                          <TableCell header>
                            <div className="flex gap-4 items-center">
                              <span>Email</span>
                            </div>
                          </TableCell>
                          <TableCell header>
                            <div className="flex gap-4 items-center">
                              <span>Phone</span>
                            </div>
                          </TableCell>
                          <TableCell header>
                            <div className="flex gap-4 items-center">
                              <span>Deals Won</span>
                            </div>
                          </TableCell>
                          <TableCell header>
                            <div className="flex gap-4 items-center">
                              <span>Total Transactions</span>
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {apiData?.map((eachList, index) => {
                          return (
                            <TableRow key={`${index}`}>
                              <TableCell sticky>
                                <div
                                  className={`${Style.tableActionArea} !gap-4`}
                                >
                                  {eachList?.name ? (
                                    <>
                                      <div className="flex items-center gap-3">
                                        <div>
                                          {eachList?.userimg ? (
                                            <img
                                              className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium object-cover object-center"
                                              src={eachList?.userimg}
                                              alt={eachList?.name}
                                              onError={(e) => {
                                                e.target.classList.add(
                                                  "hidden"
                                                );
                                                if (e.target.parentElement) {
                                                  e.target.parentElement.innerHTML = `
                                          <div class="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                            ${
                                              eachList?.name?.split(
                                                " "
                                              )[0]?.[0] || ""
                                            }${
                                                    eachList?.name?.split(
                                                      " "
                                                    )[1]?.[0] || ""
                                                  }
                                          </div>`;
                                                }
                                              }}
                                            />
                                          ) : (
                                            <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                              {eachList?.name?.split(" ")[0]
                                                ? eachList?.name?.split(
                                                    " "
                                                  )[0][0]
                                                : ""}
                                              {eachList?.name?.split(" ")[1]
                                                ? eachList?.name?.split(
                                                    " "
                                                  )[1][0]
                                                : ""}
                                            </div>
                                          )}
                                        </div>
                                        <div className="font-medium leading-5">
                                          {eachList?.name}
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              </TableCell>
                              <TableCell>
                                {eachList?.email ? (
                                  <a href={`mailto:${eachList?.email}` || ""}>
                                    {eachList?.email || "--"}
                                  </a>
                                ) : (
                                  "--"
                                )}
                              </TableCell>
                              <TableCell>{eachList?.phone || "--"}</TableCell>
                              <TableCell>
                                {eachList?.deals_won || "--"}
                              </TableCell>
                              <TableCell>
                                {eachList?.total_transaction_amount || "--"}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="get-logs"
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="get-logs"
        />
      )}

      {quickViewType === "deal" && (
        <DealQuickView
          onClose={() => {
            setQuickViewType(null);
            setEmpData({});
          }}
          data={{ ...empData, dealid: empData?.entity?.id }}
        />
      )}

      {quickViewType === "lead" && (
        <LeadQuickView
          onClose={() => {
            setQuickViewType(null);
            setEmpData({});
          }}
          data={{ ...empData, leadid: empData?.entity?.id }}
        />
      )}

      {quickViewType === "contact" && (
        <ContactQuickView
          onClose={() => {
            setQuickViewType(null);
            setEmpData({});
          }}
          data={{ ...empData, userid: empData?.entity?.id }}
        />
      )}

      {quickViewType === "account" && (
        <AccountQuickView
          onClose={() => {
            setQuickViewType(null);
            setEmpData({});
          }}
          data={{ ...empData, userid: empData?.entity?.id }}
        />
      )}

      {quickViewType === "project" && (
        <ProjectQuickView
          onClose={() => {
            setQuickViewType(null);
            setEmpData({});
          }}
          data={{ ...empData, projectkey: empData?.entity?.data?.projectkey }}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default TopAccountList;
